import axios, { AxiosPromise } from "axios";
import Storage from "../util/Storage";
import { BrandDataDto, LogoDto, UploadedFontDto } from "../domain/BrandDataDto";
import { env } from "../env/env";
import { BrandLogoDto } from "../generated/account-client";

const BrandApi = {
  getBrand(locationId: number): AxiosPromise<BrandDataDto> {
    return axios.get(
      `${env.accountContextPath}/api/v1/brands/location`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
        params: {
          locationId: locationId,
        },
      }
    );
  },

  saveBrand(brand: Partial<BrandDataDto>): AxiosPromise<BrandDataDto> {
    return axios.put(
      `${env.accountContextPath}/api/v1/brands`,
      brand,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  deleteLogo(id: string): AxiosPromise<void> {
    return axios.delete(
      `${env.accountContextPath}/api/v1/brands/logo/${id}`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  uploadLogo(brandId: string, body: FormData): AxiosPromise<LogoDto> {
    return axios.post(
      `${env.accountContextPath}/api/v1/brands/${brandId}/logo/upload`,
      body,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  uploadFont(brandId: string, body: FormData): AxiosPromise<UploadedFontDto> {
    return axios.post(
      `${env.accountContextPath}/api/v1/brands/${brandId}/font/upload`,
      body,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  deleteFont(id: string): AxiosPromise<void> {
    return axios.delete(
      `${env.accountContextPath}/api/v1/brands/uploadedfont/${id}`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },

  copyFromLocation(id: string, copyFromLocId: number): AxiosPromise<BrandDataDto> {
    return axios.post(
      `${env.accountContextPath}/api/v1/brands/${id}/copy/${copyFromLocId}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    )
  },

  updateLogoAltText(logoId: string, altText: string): AxiosPromise<BrandLogoDto> {
    return axios.post(
      `${env.accountContextPath}/api/v1/brands/${logoId}/logo/altText`,
      {},
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
        params: { altText }
      }
    )
  }
};

export default BrandApi;
